var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModalArrowGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 6,
    viewBox: "0 0 9 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.24999 5.88867L0.185558 1.24361C-0.0872035 0.931878 -0.0556159 0.458056 0.256112 0.185295C0.567839 -0.0874665 1.04166 -0.0558783 1.31442 0.255849L4.24999 3.61078L7.18556 0.25585C7.45832 -0.0558778 7.93214 -0.0874658 8.24387 0.185296C8.5556 0.458057 8.58718 0.931879 8.31442 1.24361L4.24999 5.88867Z",
    fill: "#D7EED5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalArrowGreen);
export default __webpack_public_path__ + "static/media/modal-arrow-green.582992b978dfc0e88b446c040ac47eca.svg";
export { ForwardRef as ReactComponent };